import * as React from 'react';
import { ImageInput, ImageField } from 'react-admin';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import playerPlaceholder from '../assets/player-placeholder.svg';

const PhotoPlaceholder = () => (
  <div className="fs-photo-placeholder">
    <img src={playerPlaceholder} alt="Заглушка фотографии" />
    <div>
      <CloudUploadOutlined />
      <strong>Перетащите фотографию сюда</strong>
      <span>или нажмите, чтобы выбрать JPG / PNG</span>
    </div>
  </div>
);

export const PlayerPhotoCreateInput = () => (
  <ImageInput
    className="fs-photo-create"
    label="Фотография игрока"
    source="avatar"
    accept="image/*"
    placeholder={<PhotoPlaceholder />}
  >
    <ImageField source="avatar" title="title" />
  </ImageInput>
);

export default PlayerPhotoCreateInput;
